import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { cn } from '@/shared/lib/utils'
import { Card } from '@/components/ui/card'
import {
  type ExtractionProgressStep,
  ProgressStepRow,
} from '@/components/extraction-progress-checklist'
import { buildStandardApplicabilityExtractionSteps } from '../utils/standardApplicabilityDiscoveryExtractionSteps'
import { type StandardApplicabilityDiscoveryTaskState } from '../utils/standardApplicabilityDiscoveryTaskState'

function TypeSectionStepRows({ step }: { step: ExtractionProgressStep }) {
  const subRows = step.children
  if (subRows != null && subRows.length > 0) {
    const parentRow: ExtractionProgressStep = { ...step, children: undefined }
    return (
      <>
        <ProgressStepRow key={step.id} step={parentRow} nested={false} />
        {subRows.map((child) => (
          <ProgressStepRow key={child.id} step={child} nested={false} />
        ))}
      </>
    )
  }

  return <ProgressStepRow key={step.id} step={step} nested={false} />
}

export function StandardApplicabilityDiscoveryProgress({
  state,
  className,
}: {
  state: StandardApplicabilityDiscoveryTaskState
  className?: string
}) {
  const { t } = useTranslation('machineryDirectiveCompliance')
  const steps = useMemo(
    () => buildStandardApplicabilityExtractionSteps(state, t),
    [state, t]
  )

  const headingLabel = t('onboarding.standardApplicabilityDiscovery.heading')

  return (
    <Card
      className={cn(className, 'px-4 py-3')}
      role='region'
      aria-label={headingLabel}
    >
      <ul className='space-y-3' role='list'>
        {steps.map((step) => (
          <TypeSectionStepRows key={step.id} step={step} />
        ))}
      </ul>
    </Card>
  )
}
